export default __webpack_public_path__ + "static/media/payroll-2.22e5c383.svg";